import { ReactElement, useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { TextContent } from 'src/v3/core/types'
import DangerousHtml from '../../../components/common/dangerous-html'
import {
  selectCurrentStep,
  selectStreamItems,
  stepCompleted,
} from '../classroom.slice'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let streamItems = useAppSelector(selectStreamItems)
  let currentStep = useAppSelector(selectCurrentStep)
  let data = streamItems[currentStep] as TextContent

  useEffect(() => {
    dispatch(stepCompleted())
  }, [])

  return <DangerousHtml htmlVal={data.content} isEncoded={true} />
}
